module.exports = __webpack_public_path__ + "static/img/eilis.63937cb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eilis.jpeg
// module id = Trqe
// module chunks = 1